import React, { useMemo } from 'react';
import NumberFormat from 'react-number-format';
import { Box, InputAdornment } from '@mui/material';
import RemoveIcon from '@mui/icons-material/RemoveRounded';
import AddIcon from '@mui/icons-material/AddRounded';

import { StyledTextField } from './index.style';

const NumberFormatCustom = React.forwardRef((props, ref) => {
  const { onChange, suffix, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      suffix={suffix}
    />
  );
});

const CustomNumberInput = ({
  className = '',
  value,
  onChange,
  min,
  max,
  suffix,
  valueRange,
  ...props
}) => {
  let displayValue = useMemo(() => {
    if (value === null || value === undefined) return '';
    return value;
  }, [value]);

  const increase = () => {
    const newValue = value + valueRange;
    if (max !== undefined && newValue >= max) {
      onChange(max);
      return;
    }
    onChange(newValue);
  };

  const decrease = () => {
    const newValue = value - valueRange;
    if (min !== undefined && newValue <= min) {
      onChange(min);
      return;
    }
    onChange(newValue);
  };

  const handleChange = (event) => {
    displayValue = event.target.value;
  };

  const handleBlur = () => {
    if (displayValue > max) {
      onChange(max);
      return;
    }

    if (displayValue < min) {
      onChange(min);
      return;
    }

    onChange(displayValue);
  };

  return (
    <StyledTextField
      className={className}
      size="small"
      variant="outlined"
      value={displayValue}
      onChange={handleChange}
      onBlur={handleBlur}
      {...props}
      InputProps={{
        startAdornment: (
          <InputAdornment position="end">
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              data-id="change-punct-duration"
            >
              <RemoveIcon onClick={decrease} className="icon-input" />
            </Box>
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment position="start">
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              data-id="change-punct-duration"
            >
              <AddIcon onClick={increase} className="icon-input" />
            </Box>
          </InputAdornment>
        ),
        inputComponent: NumberFormatCustom,
        inputProps: { suffix },
      }}
    />
  );
};

export default CustomNumberInput;
